import "./Home.scss";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import Accordion from "react-bootstrap/Accordion";
import Stats from "../../Components/Stats/Stats";

//Videos
import frugalVideo from "../../Assets/Videos/ff_promo.mp4";

//Images
import aboutImg from "../../Assets/Images/aboutImgs.png";
import featureImg from "../../Assets/Images/featuresImage.png";
import logo from "../../Assets/Images/logo.png";
import checkBox from "../../Assets/Images/checkBox.png";

//Icons
import apple from "../../Assets/Icons/apple.svg";
import windows from "../../Assets/Icons/windows.svg";
import gift from "../../Assets/Icons/gift.svg";
import deal from "../../Assets/Icons/deal.svg";
import bug from "../../Assets/Icons/bug.svg";
import ping from "../../Assets/Icons/ping.svg";

//BackgroundImgs
import aboutText from "../../Assets/Images/aboutText.png";
import backDots from "../../Assets/Images/backgroundDots.png";
import backTri from "../../Assets/Images/backgroundTriangle.png";
import backCircle from "../../Assets/Images/backgroundCircle.png";
import backSquare from "../../Assets/Images/backgroundSquare.png";
import featureText from "../../Assets/Images/featuresText.png";

function Landing() {
  return (
    <div id="landing">
      <div className="waveGradient">
        <Navbar homeNav="navbar navbar-expand-lg bg-custom" />
        <div className="landingContent">
          <h1 className="landingTitle" data-aos="fade-down">
            Revolutionizing the Price Error Industry
          </h1>
          <p
            className="landingParagraph"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            The most intuitive all in one software built to maximize your
            experience. The first ever software to detect all pricing errors,
            deals, and glitches all in one place.
          </p>
          <div
            className="landingBtns"
            data-aos="fade-down"
            data-aos-delay="400"
          >
            <a href="/#plan">
              <div className="btn landingButton text-nowrap buttonWhite">
                Buy Now
              </div>
            </a>
            <a href="/#about">
              <div className="btn landingButton text-nowrap">Learn More</div>
            </a>
          </div>
          <div className="analytics" data-aos="fade-up" data-aos-delay="400">
            <Stats />
          </div>
        </div>
        <div className="platformContainer">
          {/* <div class="platformBox">
            <img className="platformIcon" src={apple} alt="logo" />
          </div> */}
          <div class="platformBox">
            <img className="platformIcon" src={windows} alt="logo" />
          </div>
        </div>
      </div>
    </div>
  );
}

function About() {
  return (
    <div id="about" data-aos="fade-up" data-aos-duration="500">
      <img className="backgroundText" src={aboutText} alt="about" />
      <img className="backDots" src={backDots} alt="dots" />
      <img className="backTri" src={backTri} alt="triangles" />
      <div className="aboutContent">
        <img className="aboutImages" src={aboutImg} alt="images" />
        <div className="aboutText">
          <p id="sectionHeader">Freebie Frenzy</p>
          <h2>About us & our mission</h2>
          <p className="aboutParagraph">
            We help make sourcing <b>easier</b>. With the power of <b>AI</b> we
            can scan for the best deals through the nations largest retailers.
          </p>
          <p className="aboutParagraph">
            Browse through our catalog and set up custom alerts at your favorite
            retailers. <b>Minimize</b> the sourcing, <b>Maximize</b> your
            savings. Quality {">"} Quantity. It does not get any better than
            this.
          </p>
        </div>
      </div>
    </div>
  );
}

function Success() {
  return (
    <div id="success" data-aos="fade-up" data-aos-duration="500">
      <div className="waveGradient">
        <div className="successContent">
          <p id="sectionHeader" className="whiteHeader">
            100% off Amazon Prime Day
          </p>
          <h2 className="whiteHeading">Member success</h2>
          <video
            webkit-playsinline
            playsinline
            autoPlay
            muted
            loop
            controls
            className="video"
            width="100%"
            height="auto"
            src={frugalVideo}
            type="video/mp4"
          />
        </div>
      </div>
    </div>
  );
}

function Features() {
  return (
    <div
      id="features"
      data-aos="fade-up"
      data-aos-anchor=".featureContent"
      data-aos-duration="500"
    >
      <span className="pinkCircle"></span>
      <span className="blueCircle"></span>
      <img className="backgroundFeatureText" src={featureText} alt="backText" />
      <div className="featureContent">
        <div className="aboutText">
          <p id="sectionHeader" className="featuresHeader">
            Features
          </p>
          <h2 className="featuresHeading">Currently Support</h2>
          <div className="aboutGrid">
            <div className="featureItem">
              <div className="box">
                <img className="featureIcons" src={gift} alt="gift" />
              </div>
              <h4>Amazon Freebies</h4>
              <p className="featureText">
                We find 100% off Amazon items 100% of the time. Nothing beats
                free.
              </p>
            </div>
            <div className="featureItem">
              <div className="box">
                <img className="featureIcons" src={deal} alt="deal" />
              </div>
              <h4>Deal Detection</h4>
              <p className="featureText">
                Did we miss anything? We have a team of deal hunters always on
                the hunt! Gain access to our community{" "}
                <a href="https://www.frugalseason.com/">
                  <b>here</b>
                </a>{" "}
                to see the latest deals.
              </p>
            </div>
            <div className="featureItem">
              <div className="box">
                <img className="featureIcons" src={bug} alt="bug" />
              </div>
              <h4>Web Scraper</h4>
              <p className="featureText">
                Scanning the nation's biggest retailers for the latest price
                errors, deals, and glitches so you don't have to.
              </p>
            </div>
            <div className="featureItem">
              <div className="box">
                <img className="featureIcons" src={ping} alt="ping" />
              </div>
              <h4>Personal Pinger</h4>
              <p className="featureText">
                Hard to source through our catalog? Don't worry! Set your own
                filters on products and deals the way YOU want.
              </p>
            </div>
          </div>
        </div>
        <div className="imgContainer">
          <img className="featureImg" src={featureImg} alt="images" />
          <img className="backgroundCircle" src={backCircle} alt="circle" />
          <img className="backgroundSquare" src={backSquare} alt="square" />
        </div>
      </div>
    </div>
  );
}

function Plan() {
  return (
    <div
      id="plan"
      data-aos="fade-up"
      data-aos-anchor=".planContent"
      data-aos-duration="500"
    >
      <div className="waveGradient">
        <div className="planContent">
          <p id="sectionHeader" className="whiteHeader">
            Pricing Plans
          </p>
          <h2 className="whiteHeading">Membership includes</h2>
          <div className="planGrid">
            <div className="planCard">
              <div className="cardHeader">
                <h3 className="planPrice">
                  $150 <span className="infoText">Initial + $50/mo</span>
                </h3>
                <img className="navlogo" src={logo} alt="logo" />
              </div>
              <ul className="planFeatures">
                <li className="planFeature">
                  <img className="checkBox" src={checkBox} alt="check" />
                  <p className="planFeatureText">Full Access to the Software</p>
                </li>
                <li className="planFeature">
                  <img className="checkBox" src={checkBox} alt="check" />
                  <p className="planFeatureText">Amazon Freebies </p>
                </li>
                <li className="planFeature">
                  <img className="checkBox" src={checkBox} alt="check" />
                  <p className="planFeatureText">Amazon Price Errors</p>
                </li>
                <li className="planFeature">
                  <img className="checkBox" src={checkBox} alt="check" />
                  <p className="planFeatureText">1,000+ Deals Daily</p>
                </li>
                <li className="planFeature">
                  <img className="checkBox" src={checkBox} alt="check" />
                  <p className="planFeatureText">Personal Pinger</p>
                </li>
                <li className="planFeature">
                  <img className="checkBox" src={checkBox} alt="check" />
                  <p className="planFeatureText">1-on-1 Support</p>
                </li>
              </ul>
              <a
                href="https://dashboard.freebiefrenzy.io/checkout/plan_uvZi2nv0Cqtj1?d2c=true"
                className="btn joinNowBtn text-nowrap"
              >
                Buy Now
              </a>
            </div>
            {/* <div className="signUp">
              <h3 className="signUpHeader">Check out our mailing list</h3>
              <p className="signUpText">Subscribe to our email newsletter. We drop tons of free leads and prizes.</p>
              <div className="emailContainer">
                <div className="emailContainer">
                  <form className="form-group">
                    <input
                      type="text"
                      className="inputEmail"
                      placeholder="Enter email"
                    />
                  </form>
                  <button className="submitBtn">Get updates</button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

function Faq() {
  return (
    <div id="faq" data-aos="fade-up" data-aos-duration="500">
      <div className="faqContent">
        <p id="sectionHeader">FAQ</p>
        <h2 className="featuresHeading">Frequently Asked Questions</h2>
        <div className="faqAccordian">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>How do I get Freebie Frenzy?</Accordion.Header>
              <Accordion.Body>
                Freebie Frenzy is limited in order to maintain high success for
                our users. We will be selecting users from the{" "}
                <a href="https://dashboard.freebiefrenzy.io/checkout/plan_uvZi2nv0Cqtj1?d2c=true">
                  <b>waitlist</b>
                </a>{" "}
                randomly.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                What sites do we currently support?
              </Accordion.Header>
              <Accordion.Body>
                We support Amazon + Warehouse, Lowes, Home Depot, Target, and
                more.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                What operating systems do you currently support?
              </Accordion.Header>
              <Accordion.Body>We support Windows only for now.</Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>Is there a task limit?</Accordion.Header>
              <Accordion.Body>
                The current task limit is 200 to preserve the exclusivity of our
                software.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>Do I need proxies?</Accordion.Header>
              <Accordion.Body>
                We strongly recommend using proxies if you are running a large
                amount of tasks, but it is not required.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                What kind of Amazon accounts do you support?
              </Accordion.Header>
              <Accordion.Body>
                We support all types of Amazon accounts including business
                accounts, teen accounts, and even non-prime accounts.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  );
}

function Home() {
  return (
    <div>
      <Landing />
      <About />
      <Success />
      <Features />
      <Plan />
      <Faq />
      <Footer homeNav="navbar navbar-expand-lg  bg-custom" />
    </div>
  );
}

export default Home;
